import axios from 'axios';

const resetPassword = (data) => (
  axios.put(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/auth/password/set`,
    data,
  ));

export default resetPassword;
